import React from "react";
import { cn } from "@/lib/utils";

const STYLES = {
  "In Warehouse": { cls: "bg-slate-50 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  "Empty in Warehouse": { cls: "bg-slate-50 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  "In Warehouse with DSK": { cls: "bg-sky-50 text-sky-800 ring-sky-200", dot: "bg-sky-500" },
  Created: { cls: "bg-slate-50 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  Reserved: { cls: "bg-amber-50 text-amber-800 ring-amber-200", dot: "bg-amber-500" },
  "Ready to Ship": { cls: "bg-blue-50 text-blue-800 ring-blue-200", dot: "bg-blue-500" },
  Packed: { cls: "bg-blue-50 text-blue-800 ring-blue-200", dot: "bg-blue-500" },
  "Packed with Product": { cls: "bg-blue-50 text-blue-800 ring-blue-200", dot: "bg-blue-500" },
  Shipped: { cls: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" },
  "In Transit to Store": { cls: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" },
  "In Transit Back to Warehouse": { cls: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" },
  "Box Return In Transit": { cls: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" },
  Delivered: { cls: "bg-cyan-50 text-cyan-800 ring-cyan-200", dot: "bg-cyan-500" },
  "Delivered to Store": { cls: "bg-cyan-50 text-cyan-800 ring-cyan-200", dot: "bg-cyan-500" },
  "Waiting for Return": { cls: "bg-orange-50 text-orange-800 ring-orange-200", dot: "bg-orange-500" },
  "Waiting for Box Return": { cls: "bg-orange-50 text-orange-800 ring-orange-200", dot: "bg-orange-500" },
  Installed: { cls: "bg-emerald-50 text-emerald-800 ring-emerald-200", dot: "bg-emerald-500" },
  "Returned to Warehouse": { cls: "bg-emerald-50 text-emerald-800 ring-emerald-200", dot: "bg-emerald-500" },
  "Box Returned": { cls: "bg-emerald-50 text-emerald-800 ring-emerald-200", dot: "bg-emerald-500" },
  Returned: { cls: "bg-teal-50 text-teal-800 ring-teal-200", dot: "bg-teal-500" },
  Closed: { cls: "bg-slate-100 text-slate-600 ring-slate-300", dot: "bg-slate-500" },
  Damaged: { cls: "bg-rose-50 text-rose-800 ring-rose-200", dot: "bg-rose-500" },
  Missing: { cls: "bg-rose-50 text-rose-800 ring-rose-200", dot: "bg-rose-500" },
  "Issue / Exception": { cls: "bg-rose-50 text-rose-800 ring-rose-200", dot: "bg-rose-500" },
};

export function StatusBadge({ status }) {
  const s = STYLES[status] || STYLES["In Warehouse"];
  return (
    <span className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset", s.cls)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {status}
    </span>
  );
}
